<template>
    <v-img src="https://assets.crossref.org/logo/crossref-logo-100.png" alt="Crossref logo"  aspect-ratio="1.538" max-height="50px" max-width="72px" min-height="36px" min-width="72px"/>
</template>

<script>
/**
 * The horizontal Crossref logo served from the assets CDN
 */
export default {
  name: 'BaseCrossrefLogoStacked'
}
</script>

<style lang="sass">
  //
</style>
